import { render, staticRenderFns } from "./AddBalanceModal.vue?vue&type=template&id=b11dd8e0"
import script from "./AddBalanceModal.vue?vue&type=script&lang=js"
export * from "./AddBalanceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports